import { render, staticRenderFns } from "./AffiliateBlurb.vue?vue&type=template&id=401b5b4c&scoped=true&"
import script from "./AffiliateBlurb.vue?vue&type=script&lang=js&"
export * from "./AffiliateBlurb.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateBlurb.vue?vue&type=style&index=0&id=401b5b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b5b4c",
  null
  
)

export default component.exports